// Selection actions belong to answer text, never to interactive controls.
const CONTROL_SELECTOR = 'button,[role="button"],[role="radio"],[role="checkbox"],[role="switch"],[role="tab"],[role="slider"],input,select,textarea,[contenteditable="true"]';

export function isMessageControlNode(node) {
  const element = node?.nodeType === 1 ? node : node?.parentElement;
  return !!element?.closest?.(CONTROL_SELECTOR);
}
